// Simple counter for generating sequential IDs
let phaseCounter = 0;
let taskCounter = 0;

/**
 * Generates a stable, unique ID for a phase
 * @returns {string} A unique phase ID
 */
export const generatePhaseId = () => {
  return `phase-${++phaseCounter}-${Date.now()}`;
};

/**
 * Generates a stable, unique ID for a task
 * @param {string} phaseId - The ID of the parent phase
 * @returns {string} A unique task ID
 */
export const generateTaskId = (phaseId) => {
  return `task-${phaseId}-${++taskCounter}`;
};

/**
 * Resets the ID counters (useful for testing)
 */
export const resetIdCounters = () => {
  phaseCounter = 0;
  taskCounter = 0;
};
